// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-XzykO";
var _3 = "bottom-8cYHn";
var _4 = "link-1-7Az";
var _5 = "arrowWrapper-2eV6L";
var _6 = "servicesIcons-2FZZG";
export { _1 as "__esModule", _2 as "container", _3 as "bottom", _4 as "link", _5 as "arrowWrapper", _6 as "servicesIcons" }
export default { "__esModule": _1, "container": _2, "bottom": _3, "link": _4, "arrowWrapper": _5, "servicesIcons": _6 }
